// Author Lidongxu
// Date 2025-05-27 12:04:34

import * as model from "@/model/em/epc/EmEpcBindHisModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmEpcBindHis(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_EPC_URL,
    })
    .buildStore()
